export default {
  name: 'Нэр',
  tel: 'Утас',
  save: 'Save',
  confirm: 'Тийм',
  cancel: 'Үгүй',
  delete: 'Устгах',
  complete: 'Дууссан',
  loading: 'Ачааллаж байна...',
  telEmpty: 'Утасны дугаараа оруулна уу!',
  nameEmpty: 'Овог, Нэр',
  nameInvalid: 'Бүтэн нэрээ бичнэ үү.',
  confirmDelete: 'Устгахыг зөвшөөрч байна уу?',
  telInvalid: 'Утасны дугаар',
  vanCalendar: {
    end: 'end',
    start: 'start',
    title: 'Хугацаа сонгох',
    confirm: 'Тийм',
    startEnd: 'Эхлэх/Дуусах',
    weekdays: ['Ням', 'Даваа', 'Мягмар', 'Лхагва', 'Пүрэв', 'Баасан', 'Бямба'],
    monthTitle: function monthTitle(year, month) {
      return year + "жил" + month + "сар";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return " Сонгосон өдрүүд хэтэрч болохгүй " + maxRange + " өдөр";
    }
  },
  vanContactCard: {
    addText: 'Холбоо барих хүн'
  },
  vanContactList: {
    addText: 'Холбоо барих хүн'
  },
  vanPagination: {
    prev: 'Өмнөх хуудас',
    next: 'Дараагийн хуудас'
  },
  vanPullRefresh: {
    pulling: 'Pull down to refresh...',
    loosing: 'Release to refresh...'
  },
  vanSubmitBar: {
    label: 'Нийт：'
  },
  vanCoupon: {
    unlimited: 'Ашиглах боломжгүй',
    discount: function discount(_discount) {
      return _discount + "折";
    },
    condition: function condition(_condition) {
      return "满" + _condition + "元可用";
    }
  },
  vanCouponCell: {
    title: 'Купон',
    tips: 'Боломжгүй',
    count: function count(_count) {
      return _count + "张可用";
    }
  },
  vanCouponList: {
    empty: 'Купон байхгүй',
    exchange: 'Солих',
    close: 'Купон байхгүй',
    enable: 'Боломжтой',
    disabled: 'Боломжгүй',
    placeholder: 'Купоны кодыг оруулна уу'
  },
  vanAddressEdit: {
    area: 'Area',
    postal: 'postal',
    areaEmpty: 'Сонгоно уу',
    addressEmpty: 'Хаяг',
    postalEmpty: 'Postal код буруу',
    defaultAddress: 'Хаяг',
    telPlaceholder: 'Хүлээж авах хүний утасны дугаар',
    namePlaceholder: 'Нэр',
    areaPlaceholder: 'Аймаг / Хот / Дүүрэг'
  },
  vanAddressEditDetail: {
    label: 'Хаяг',
    placeholder: 'Дэлгэрэнгүй хаяг'
  },
  vanAddressList: {
    add: 'Хаяг нэмэх'
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/mongolian.js